import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { TRIAL_BALANCE_REPORT_API } from "./apiRoutes";

interface UseGetTrialBalanceDocReportExportProps {
  postDocHeaderId: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTrialBalanceDocReportExport = async (postDocHeaderId: string, communityId: string) =>
  await axiosAuth.get(`${TRIAL_BALANCE_REPORT_API(communityId)}/documents/${postDocHeaderId}/export`, {
    responseType: 'blob'
  });

const useGetTrialBalanceDocReportExport = ({
  postDocHeaderId,
  communityId,
  queryParams,
}: UseGetTrialBalanceDocReportExportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["trial-balance-doc-report-export", postDocHeaderId],
    queryFn: () => getTrialBalanceDocReportExport(postDocHeaderId, communityId),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!postDocHeaderId && !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetTrialBalanceDocReportExport;
